exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".group_body {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column; }\n  .group_body .paramForm {\n    display: contents; }\n\n.value_input {\n  margin-bottom: 2rem; }\n\n.inputCheck {\n  margin: 1rem 0 2rem 0;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  gap: 1rem; }\n\nbutton {\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n  -ms-flex-item-align: end;\n      align-self: flex-end; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/dialog/param-type-dialog/param-type-dialog.component.scss
// module id = ../../../../../src/app/components/dialog/param-type-dialog/param-type-dialog.component.scss
// module chunks = main